import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ValidationResultsComponent } from './validation-results.component';
import { ValidationMessageCountComponent } from './validation-message-count.component';
import { SharedDirectivesModule } from '../../../shared/directives/shared-directives.module';

@NgModule({
    declarations: [ ValidationResultsComponent, ValidationMessageCountComponent ],
    imports: [ CommonModule, SharedDirectivesModule ],
    exports: [ ValidationResultsComponent, ValidationMessageCountComponent ]
})
export class ValidationResultsModule {}
